import { render, staticRenderFns } from "./EmptyContent.vue?vue&type=template&id=1f09f2c4&scoped=true&"
import script from "./EmptyContent.vue?vue&type=script&lang=ts&"
export * from "./EmptyContent.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyContent.vue?vue&type=style&index=0&id=1f09f2c4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f09f2c4",
  null
  
)

export default component.exports